import { render, staticRenderFns } from "./DatiAppMetabase.vue?vue&type=template&id=2c85282a&"
import script from "./DatiAppMetabase.vue?vue&type=script&lang=js&"
export * from "./DatiAppMetabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports